import React, { useState } from 'react';
import './faqs.css';

function FAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What services do you offer?",
      answer: "We offer a variety of services including eye exams, prescription glasses, contact lens fittings, and treatment for common eye conditions. Our team of optometrists is here to provide comprehensive care."
    },
    {
      question: "How do I book an appointment?",
      answer: "You can book an appointment by calling us at  0112682277  , emailing eyeclinicandopticalateyecare@gmail.com, or using the 'Book Appointment' feature on our website."
    },

    {
      question: "What are your business hours?",
      answer: "Our regular business hours are Monday to Saturday, 8 AM to 8 PM. We are closed on Sundays."
    },
    {
      question: "What should I bring to my eye exam appointment?",
      answer: "any prescription lenses you currently wear."
    },
  ];

  return (
    <div className="faq-container">
      <header className="faq-header">
        <h1>Frequently Asked Questions (FAQ)</h1>
      </header>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleAnswer(index)}>
              <p>{faq.question}</p>
              <span className="faq-toggle-icon">{activeIndex === index ? '-' : '+'}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <footer className="faq-footer">
        <p>For more information, feel free to contact us!</p>
      </footer>
    </div>
  );
}

export default FAQs;
